
import React, {Component} from 'react';
import {translate}	from 'react-i18next';
import {Table} from 'react-bootstrap';
import swal from 'sweetalert';

var Config = require('../../../config');

class SampleResult extends Component{
	constructor(props){
		super(props);

		this.getList = this.getList.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.searching = this.searching.bind(this);
		this.filter = this.filter.bind(this);

		var aux_date = new Date();

		this.state = {
			results: [],
			filter:"all",
			start_date 	: aux_date.getFullYear()+'-'+("0" + (aux_date.getMonth() + 1)).slice(-2)+'-'+("0" + aux_date.getDate()).slice(-2),
			end_date 	: aux_date.getFullYear()+'-'+("0" + (aux_date.getMonth() + 1)).slice(-2)+'-'+("0" + aux_date.getDate()).slice(-2),
			start_folio:"",
			end_folio:"",
			filterText:""
		}
	}

	componentDidMount(){
		this.getList();
	}

	getList(){
		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'samples/for_patients?health_facilities_id='+sessionStorage.getItem('health_facilities_id')+
			'&filter='+this.state.filter+'&start_date='+this.state.start_date+'&end_date='+this.state.end_date+
			'&start_folio='+this.state.start_folio+'&end_folio='+this.state.end_folio, {
			method: 'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					results: response
				});
			}
		});
	}

	handleChange(e){
		this.setState({
			[e.target.name]: e.target.value
		});
	}

	searching(){
		this.getList();
	}

	filter(row){ 
    	var res = true;

    	if(row !== null){
      		if(
		        row.donor !== null &&
		        row.number !== null &&
		        row.sample_type !== null &&
		        row.timestamp !== null 
      		){
        		if(
		          	row.donor.indexOf(this.props.filterText.toUpperCase()) !== -1 ||
		          	row.number.toString().indexOf(this.props.filterText.toUpperCase()) !== -1 ||
		          	row.sample_type.indexOf(this.props.filterText.toUpperCase()) !== -1 ||
		          	row.timestamp.toString().indexOf(this.props.filterText.toUpperCase()) !== -1 
          
        		){
          			res = true;
        		}else{
          			res = false;
        		}
      		}
    	}

    	return res;

  	}

	render(){
		const {t} = this.props;
		var session = sessionStorage.getItem('health_facilities_name');

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
						{session} ->
						{t('sidebar.nav.home.MAIN')} -> 
						{t('sidebar.nav.patients.MAIN')} ->
          				Resultados Muestras
					</h5>
				</div>
				<form noValidate>
				

					<div className="col-xs-12 form-group">
						<div className="col-xs-12 col-sm-2">
							<span className="span-min">Buscar</span>
							<input type="text" className="form-control" name="filterText" id="filterText" 
								value={this.state.filterText} placeholder="Filtro..." onChange={this.handleChange}  />
						</div>
						<div className="col-xs-12 col-sm-10">
							<div className="col-xs-12 col-sm-2">
								<span className="span-min">Feha Desde</span>
								<input type="date" className="form-control hour-input" name="start_date" id="start_date" 
									value={this.state.start_date} onChange={this.handleChange}  />
							</div>
							<div className="col-xs-12 col-sm-2">
								<span className="span-min">Fecha Hasta</span>
								<input type="date" className="form-control hour-input" name="end_date" id="end_date" 
									value={this.state.end_date} onChange={this.handleChange}  />
							</div>
							<div className="col-xs-12 col-sm-2">
								<span className="span-min">Folio Desde</span>
								<input type="text" className="form-control hour-input" name="start_folio" id="start_folio" 
									value={this.state.start_folio} onChange={this.handleChange}  />
							</div>
							<div className="col-xs-12 col-sm-2">
								<span className="span-min">Folio Hasta</span>
								<input type="text" className="form-control hour-input" name="end_folio" id="end_folio" 
									value={this.state.end_folio} onChange={this.handleChange}  />
							</div>
							<div className="col-xs-12 col-sm-2">
								<span className="span-min">Status</span>
								<select className="form-control" name="filter" id="filter"
									value={this.state.filter} onChange={this.handleChange}>
									<option value="all">Todos</option>
								</select>
							</div>
							<div className="col-xs-12 col-sm-1" style={{marginTop:"10px"}}>
								<button type="button" className="btn btn-info" style={{fontSize:"1em"}}	
									onClick={this.searching}>
									Buscar
								</button>
							</div>
						</div>
					</div>

					<div className="col-xs-12">
						<Table responsive hover>
							<thead>
								<tr>
									<th>No. Muestra</th>
									<th>Donador</th>
									<th>Fecha Registro</th>
									<th>Tipo Muestra</th>
									<th>INMUH</th>
									<th>SER</th>
									<th></th>
								</tr>
							</thead>
							<tbody>
								{/*this.state.results.map((res, i)=>{
									return <tr key={i}>
										<td></td>
										<td></td>
										<td></td>
										<td></td>
										<td></td>
										<td></td>
										<td>
											<button type="button" name="update"	
												disabled={!this.props.task_patient_sample_results.update || !this.props.task_patient_sample_results.create}>
												update
											</button>
										</td>
									</tr>
								})*/}
							</tbody>
						</Table>
					</div>
				</form>
			</div>
		)
	}
}


export default translate('translations') (SampleResult);